/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import PageToolbar from "../../components/PageToolbar";
import { Button, Card, Checkbox, Form, InputNumber, message } from "antd";
import GenericSelector from "../../components/GenericSelector";
import GenericSelectorSuppliers from "../../components/GenericSelectorSuppliers";
import TableIDs from "../../data/TableIDs";
import GenericSelectorItemTags from "../../components/GenericSelectorItemTags";
import GenericModal from "../../components/GenericModal";
import ResponsiveTable from "../../components/ResponsiveTable";


class OrderRecommendation extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            supplierId: null,
            storageId: null,
            marlog: null,
            itemTagList: "",
            isSuppDefault: "1",
            isCostValue: "1",

            modalCalcItems: false,
        };

        this.id = "ORDER_RECOMMENDATION";

        this.api = {
            get: "get_order_recommendation"

        }

        this.selectors = [
            { id: TableIDs.genericSelectorStorages, api: "get_storage_list" },
            { id: "INTERNAL_SUPPLIER_LIST", api: "internal_supplier_list" },
        ]

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };

        this.selectors.forEach((x) => {
            if (props.data[x.id] === undefined) { props.data[x.id] = { ...props.data.genericSelector } }
        })


    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(21615);
    }

    apiCalcItems = () => {
        const { supplierId, storageId, marlog, itemTagList, isSuppDefault, isCostValue } = this.state
        if (!supplierId || !storageId || !marlog) {
            message.error(this.getText(21631));
            return;
        }
        this.setState({ modalCalcItems: true }, () => {
            const request = { supplierId, storageId, marlog, itemTagList, isSuppDefault, isCostValue }
            this.props.dataActions.genericDataSetFilter(this.id, this.props.user.companyCode, this.props.user.token, request, this.api.get)
        })
    }

    renderCalcItemCheckbox = (text, record) => {
        let data = [...this.props.data[this.id].data]
        if (text == "All") {
            let filterChecked = data?.filter(f => f?.split("\f")[7] == 1) ?? []
            return (<Checkbox
                checked={data.length && data.length == filterChecked.length}
                indeterminate={data.length && filterChecked.length && data.length != filterChecked.length}
                onChange={e => {
                    data = data.map(r => r.split("\f").map((x, i) => i == 7 ? (e.target.checked ? "1" : "0") : x).join("\f"))
                    this.props.dataActions.setJson(this.id, { data })
                }} />)
        } else {
            return (<Checkbox checked={text == '1'} onChange={e => {
                data[record.index] = data[record.index].split("\f").map((x, i) => i == 7 ? (e.target.checked ? "1" : "0") : x).join("\f")
                this.props.dataActions.setJson(this.id, { data })
            }} />)
        }
    }

    renderOrderInput = (text, record, colIndex) => {
        return (<InputNumber value={text} onChange={e => {
            let data = [...this.props.data[this.id].data]
            let iAllOrder = 0;
            data[record.index] = data[record.index].split("\f").map((x, i) => {
                if (i < 13) {
                    return x
                } else if (i == 15) {
                    return iAllOrder
                } else {
                    let res = i == colIndex ? e : x;
                    iAllOrder += parseFloat(res ? res : 0)
                    return res
                }
            }).join("\f")
            this.props.dataActions.setJson(this.id, { data })
        }} />)
    }

    render() {
        const gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            flexDirection: 'column',
        };



        return (<div style={divStyle}>
            <Card title={<PageToolbar title={gt(21616)} actionButtons={[]} />}
                bordered={true} style={{ width: window.innerWidth > 700 ? 700 : "95%" }}
                headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }}
                actions={[<Button type="primary" onClick={this.apiCalcItems}>{gt(21623)}</Button>]}>

                <Form.Item label={gt(21617)} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} required validateStatus={this.state.supplierId ? "success" : "error"}>
                    <GenericSelectorSuppliers
                        {...this.props}
                        value={this.state.supplierId}
                        onChange={e => { this.setState({ supplierId: e }) }}
                    />
                </Form.Item>
                <Form.Item>
                    <Checkbox
                        style={{ marginRight: 100 }}
                        checked={this.state.isSuppDefault == 1}
                        onChange={e => { this.setState({ isSuppDefault: e.target.checked ? "1" : "0" }) }}
                    >{gt(21621)}</Checkbox>
                </Form.Item>
                <Form.Item>
                    <Checkbox
                        style={{ marginRight: 100 }}
                        checked={this.state.isCostValue == 1}
                        onChange={e => { this.setState({ isCostValue: e.target.checked ? "1" : "0" }) }}
                    >{gt(21622)}</Checkbox>
                </Form.Item>
                <Form.Item label={gt(21618)} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} required validateStatus={this.state.storageId ? "success" : "error"}>
                    <GenericSelector
                        {...this.props}
                        {...this.selectors[0]}
                        value={this.state.storageId}
                        onChange={e => { this.setState({ storageId: e }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21619)} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} required validateStatus={this.state.marlog ? "success" : "error"}>
                    <GenericSelector
                        {...this.props}
                        {...this.selectors[1]}
                        value={this.state.marlog}
                        onChange={e => { this.setState({ marlog: e }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21620)} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} >
                    <GenericSelectorItemTags
                        {...this.props}
                        multi
                        value={this.state.itemTagList ? this.state.itemTagList.split(",") : []}
                        onChange={e => { this.setState({ itemTagList: e ? e.join(",") : "" }) }}
                    />
                </Form.Item>

            </Card>

            <GenericModal
                visible={this.state.modalCalcItems}
                onCancel={() => { this.setState({ modalCalcItems: false }) }}
                title={gt(21624)}
                footer={[
                    <Button
                        type="primary"
                        style={{ marginLeft: 15 }}
                        disabled={!this.props.data[this.id].data?.filter(f => f?.split("\f")[7] == 1).length}
                        onClick={() => { message.error("בפיתוח......") }}
                    >{gt(21634)}</Button>,
                    <Button
                        onClick={() => { this.setState({ modalCalcItems: false }) }}
                    >{gt(21635)}</Button>,
                ]}
            >
                <ResponsiveTable
                    tableOnly
                    idTable={this.props.data[this.id]}
                    columns={[
                        { title: gt(21625), key: "iCode", dataIndex: "iCode", width: "7%", render: t => t },
                        { title: gt(21626), key: "iBarcode", dataIndex: "iBarcode", width: "7%", render: t => t },
                        { title: gt(21627), key: "iName", dataIndex: "iName", width: "12%", render: t => t },

                        { title: gt(21628), key: "iStock", dataIndex: "iStock", width: "7%", render: t => t },
                        { title: gt(21629), key: "iMinStock", dataIndex: "iMinStock", width: "7%", render: t => t },
                        { title: gt(21630), key: "iMarlogStock", dataIndex: "iMarlogStock", width: "7%", render: t => t },
                        { title: gt(21670), key: "iAverageDemand", dataIndex: "iAverageDemand", width: "7%", render: t => t },
                        { title: gt(21663), key: "iRequiredStock", dataIndex: "iRequiredStock", width: "7%", render: (t, r) => `${t} (${r.iLimitDays} ${gt(21669)})` },
                        { title: gt(21664), key: "iSizeQty", dataIndex: "iSizeQty", width: "7%", render: t => t },
                        { title: gt(21665), key: "iRecommendation", dataIndex: "iRecommendation", width: "7%", render: t => t },
                        { title: gt(21666), key: "iMarlogOrder", dataIndex: "iMarlogOrder", width: "7%", render: (t, r) => this.renderOrderInput(t, r, 13) },
                        { title: gt(21667), key: "iSupplierOrder", dataIndex: "iSupplierOrder", width: "7%", render: (t, r) => this.renderOrderInput(t, r, 14) },
                        { title: gt(21668), key: "iAllOrder", dataIndex: "iAllOrder", width: "7%", render: t => t },

                        { title: this.renderCalcItemCheckbox("All"), key: "iIsChecked", dataIndex: "iIsChecked", width: "6%", render: this.renderCalcItemCheckbox },
                    ]}
                    pagination={{ pageSize: parseInt((window.innerHeight - 300) / 40) }}
                />
            </GenericModal>
        </div>)
    }

}

export default OrderRecommendation;